export const emailServicesDomains = [
  'gmail.com',
  'hotmail.com',
  'outlook.com',
  'facebook.com',
  'mac.com',
  'googlemail.com',
  'live.com',
  'yahoo.com',
  'me.com',
  'aol.com',
  'msn.com',
  'verizon.net',
  'icloud.com',
  'rediffmail.com',
  'zohomail.in',
  'zoho.com',
  'mail.com',
  'protonmail.com',
  'yandex.com',
]

export const protectedKeyCodes = [9, 17, 18, 35, 36, 37, 38, 39, 40, 45]
